module.exports = __webpack_public_path__ + "img/hourglass-done.218a4372.png";